import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { CreateLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/location/create-location.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { LocationCreateFormStep1Controller } from '@app/feature/location/location-create/location-create-form-step-1/location-create-form-step-1.controller';
import { LocationCreateFormStep2Controller } from '@app/feature/location/location-create/location-create-form-step-2/location-create-form-step-2.controller';
import { useCreateLocationContext } from '@app/feature/location/location.context';

interface LocationCreateFormControllerProps {
  onError: SubmitErrorHandler<CreateLocationModel>;
  onSubmit: SubmitHandlerWithDirtyFields<CreateLocationModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const LocationCreateFormController = (
  props: LocationCreateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const { t } = useTranslation();
  const data = useCreateLocationContext();

  return (
    <MultiStepFormProvider<CreateLocationModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      state={state}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      items={[
        {
          title: t('$.location-create.step-1.title'),
          iconName: 'location',
          fields: ['name', 'type', 'facilities', 'openingTimes'],
          component: <LocationCreateFormStep1Controller />,
        },
        {
          title: t('$.location-create.step-2.title'),
          iconName: 'marker-pin-04',
          fields: [
            'address',
            'city',
            'postalCode',
            'country',
            'coordinates.latitude',
            'coordinates.longitude',
            'networkId',
            'customerId',
          ],
          component: <LocationCreateFormStep2Controller />,
        },
      ]}
    />
  );
};
